import { reducers } from "@insite/client-framework/Store/Reducers";
// import starterReducer from "@starter/Framework/Store/Starter/StarterReducer";

// /* Store Custom Code - Start */
import storeReducer from "@store/Framework/Store/Store/Reducers";
// /* Store Custom Code - End */

// (reducers as any).starter = starterReducer;
(reducers as any).store = storeReducer; // Store Custom Code
